export default __webpack_public_path__ + "static/media/popup_formalwear.88a72fe8.png";